/* eslint-disable react/jsx-pascal-case */
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";

// Admin
import NavbarAdmin from "./components/NavbarAdmin";
import List_colis from "./pages/Admin/List_colis";
import Add_colis from "./pages/Admin/Add_colis";
import Update_colis from "./pages/Admin/Update_colis";
// User
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Colis from "./pages/Colis";
import { isAuthentificated } from "./utils/auth-utils";

const ProtectedRoute = ({ children }) => {
  if (!isAuthentificated()) {
    return <Navigate to="/" />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  if (isAuthentificated()) {
    return <Navigate to="/admin" />;
  }
  return children;
};

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

const LayoutAdmin = () => {
  return (
    <>
      <NavbarAdmin />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: (
          <PublicRoute>
            <Home />
          </PublicRoute>
        ),
      },
      {
        path: "/colis",
        element: (
          <PublicRoute>
            <Colis />
          </PublicRoute>
        ),
      },
      {
        path: "/login",
        element: (
          <PublicRoute>
            <Login />
          </PublicRoute>
        ),
      },
    ],
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <LayoutAdmin />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/admin",
        element: <List_colis />,
      },
      {
        path: "/admin/addColis",
        element: <Add_colis />,
      },
      {
        path: "/admin/updateColis/:id",
        element: <Update_colis />,
      },
    ],
  },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
